import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ButtonTextOnly from "../../../../../../commons/Buttons/ButtonTextOnly";
import { Wrapper } from "./styled";
import colors from "../../../../../../../styles/colorPalette";
import { NEXT } from "../../constants";
import { PATH_COUPON } from "../../../../../App/constants";
import { contributorData, taxPayerData } from "../../../../../../../store/Users/selectors";
import { getContribData } from "../ContributorForm/components/ContributorInputs/constants";
import { getPayerData } from "../PayerForm/components/PayerInputs/constants";
import { isChecked } from "../../../../../../../utils/functions";

const Button = () => {
  const history = useHistory();
  const dataContributor = useSelector(contributorData);
  const dataPayer = useSelector(taxPayerData);
  const contributor = getContribData(dataContributor);
  const payer = getPayerData(dataPayer);
  const [disabled, setDisabled] = useState();

  useEffect(() => {
    setDisabled(isChecked(contributor, payer));
  }, [dataContributor, dataPayer]);

  const buttonClick = () => {
    history.push(PATH_COUPON);
  };

  return (
    <Wrapper>
      <ButtonTextOnly
        disabled={disabled}
        color={colors.white1}
        background={colors.blueDemo}
        text={NEXT}
        onClick={buttonClick}
      />
    </Wrapper>
  );
};

export default Button;
